import { Benefit, FileContentFactory, FileContent, Dependencies } from ".."

export interface ModifyBenefit {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    categoryIds: string[]
    dependencies: Dependencies | null
}

export class ModifyBenefitFactory {
    static create(): ModifyBenefit {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            descriptions: {},
            image: FileContentFactory.create(),
            categoryIds: [],
            dependencies: null,
        }
    }

    static from(benefit: Benefit): ModifyBenefit {
        const modifyBenefit: ModifyBenefit = JSON.parse(
            JSON.stringify({
                isDraft: benefit.isDraft,
                isActive: benefit.isActive,
                isDeleted: benefit.isDeleted,
                names: benefit.names,
                descriptions: benefit.descriptions,
                image: FileContentFactory.fromUrl(benefit.imageUrl ?? ""),
                categoryIds: benefit.categoryIds ?? [],
                dependencies: benefit.dependencies ?? null,
            })
        )
        return modifyBenefit
    }
}
